import React, { useEffect, useMemo } from "react";
import { Layout, ConfigProvider, theme } from "antd";
import { Routes, Route } from "react-router-dom";
import { createConfig, WagmiProvider, http } from "wagmi";
import { injected, walletConnect, coinbaseWallet } from "wagmi/connectors";
import { Buffer } from "buffer";

import {
  mainnet,
  bscTestnet,
  sepolia,
  arbitrumSepolia,
  // arbitrumSepolia,
  // arbitrum,
  // baseSepolia,
  // bsc,
  // optimism,
  // polygon,
  base,
  // avalanche,
} from "wagmi/chains";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import _ from "lodash";
import Header from "./components/Header";

// import dynamic from "next/dynamic";

// const Header = dynamic(() => import("./components/Header"), {
//   ssr: false,
// });
import "./styles/globals.css";
import "./App.css";
import Prover from "./components/prover";
import Dashboard from "./components/dashboard";
import { getChainInfoById } from "./constants/const";
import { useModalStore } from "./store/modle";
import ProviderModal from "./components/ProviderModal";
import { useDataStore } from "./store/dataStore";
import { Web3ContextProvider } from "./components/providers/Web3ContextProvider";
import StakeModal from "./components/modals/StakeModal";
import UnStakeModal from "./components/modals/UnStakeModal";
import AppBackground from "./components/AppBackground";

const { Content } = Layout;

export const wagmiConfig = createConfig({
  chains: [
    mainnet,
    sepolia,
    bscTestnet,
    // arbitrum,
    arbitrumSepolia,
    // baseSepolia,
    // bsc,
    // optimism,
    // polygon,
    base,
    // avalanche,
  ],
  transports: {
    [mainnet.id]: http(getChainInfoById(mainnet.id).rpcUrl),
    [sepolia.id]: http("https://sepolia-rpc.scroll.io"),
    [bscTestnet.id]: http(
      "https://endpoints.omniatech.io/v1/bsc/testnet/public"
    ),
    // [arbitrum.id]: http(getChainInfoById(arbitrum.id).rpcUrl),
    [arbitrumSepolia.id]: http(getChainInfoById(arbitrumSepolia.id).rpcUrl),
    // [baseSepolia.id]: http(getChainInfoById(baseSepolia.id).rpcUrl),
    // [bsc.id]: http(getChainInfoById(bsc.id).rpcUrl),
    // [optimism.id]: http(getChainInfoById(optimism.id).rpcUrl),
    // [polygon.id]: http(getChainInfoById(polygon.id).rpcUrl),
    [base.id]: http(getChainInfoById(base.id).rpcUrl),
    // [avalanche.id]: http(getChainInfoById(avalanche.id).rpcUrl),
  },
  connectors: [
    injected(),
    walletConnect({
      projectId:
        process.env.REACT_APP_PUBLIC_PROJECT_ID ||
        "1b0f2a5027525b61f7a075b6d6ab98a5",
      showQrModal: true,
      qrModalOptions: {
        enableExplorer: true,
        themeMode: "light",
        themeVariables: {
          "--wcm-z-index": "99999",
        },
      },
    }),
    coinbaseWallet(),
  ],

  // connectors: [metaMask()],
  ssr: true,
});
declare global {
  interface Window {
    ethereum?: any;
    web3: any;
    updateWeb3Modal: any;
  }
}
if (typeof window !== "undefined") {
  window.Buffer = Buffer;
}
const App: React.FC = () => {
  const queryClient = new QueryClient();
  const showProviderModal = useModalStore((state) => state.showProviderModal);
  const { setTokenPrice } = useDataStore((state) => state);
  const setIsMobile = useDataStore((state) => state.setIsMobile);
  const getPrice = async () => {
    try {
      const response = await fetch(
        "https://common-auth.brevis.network/v1/getPriceBySymbol?symbol=BREV"
      );
      // if (!response.ok) {
      //   throw new Error(`HTTP错误: ${response.status}`);
      // }
      const data = await response.json();
      setTokenPrice(data.price);
      return data;
    } catch (error) {
      console.error("get price error:", error);
    }
  };
  useEffect(() => {
    getPrice();
  }, []);
  const onResize = useMemo(
    () =>
      _.throttle(() => {
        setIsMobile(document.documentElement.clientWidth <= 768);
        if (document.documentElement.clientWidth <= 750) {
          document.getElementsByTagName("html")[0].style.fontSize =
            (document.documentElement.clientWidth / 375) * 100 + "px";
        } else {
          document.getElementsByTagName("html")[0].style.fontSize =
            (document.documentElement.clientWidth / 1440) * 100 + "px";
        }
      }, 400),
    [setIsMobile]
  );

  useEffect(() => {
    onResize();
    window?.addEventListener("resize", onResize, { passive: true });
    return () => {
      window?.removeEventListener("resize", onResize);
    };
  }, [onResize]);

  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <Web3ContextProvider>
          <ConfigProvider
            theme={{
              algorithm: theme.darkAlgorithm,
              token: {
                // colorPrimary: "#6c5ce7",
                colorBgBase: "#14161E",
                colorTextBase: "#2B303B",
              },
            }}
          >
            <Layout className="app-layout">
              <AppBackground />
              <Header />
              <div className="main-content-wrapper">
                <Content className="main-content">
                  <Routes>
                    <Route path="/" element={<Prover />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                  </Routes>
                </Content>
              </div>
              <div className="app-footer">
                <div className="footer-left">
                  © Brevis {new Date().getFullYear()}. All rights reserved.
                </div>
                <div className="footer-right">
                  <img
                    src="/s2twitter.svg"
                    alt="s2twitter"
                    width={24}
                    className="footerIcon"
                    onClick={() => {
                      window.open("https://x.com/brevis_zk", "_blank");
                    }}
                  />
                  <img
                    src="/s2Discord.svg"
                    alt="s2Discord"
                    width={24}
                    className="footerIcon"
                    onClick={() => {
                      window.open(
                        "https://discord.com/invite/QTRkjKdZ6A",
                        "_blank"
                      );
                    }}
                  />
                  {/* <img
                    src="/s2telegram.svg"
                    alt="s2telegram"
                    width={24}
                    className="footerIcon"
                    onClick={() => {
                      window.open("https://t.me/brevisnetwork", "_blank");
                    }}
                  /> */}
                </div>
              </div>
            </Layout>
            {showProviderModal && <ProviderModal />}
          </ConfigProvider>
        </Web3ContextProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};

export default App;
